export default __webpack_public_path__ + "static/media/photo--sm--kate-2.300f0622.jpg";